import { Fragment, useMemo } from "react";
import BottomIconHideWrapper from "@stadium/shared/src/components/bottom-icon-hide-wrapper";
import { InternalButton } from "@components/shared/buttons";
import {
  HOW_IT_WORKS_DATA,
  HOW_IT_WORKS_DESCRIPTION,
  HOW_IT_WORKS_HEADING,
} from "@constants/how-it-works";

import styles from "./main.module.scss";

import Modal from "@stadium/ui/src/components/ModalNew";
import {
  CloseButton,
  ModalBody,
  ModalContent,
  ModalDialog,
  ModalHeader,
  ModalFooter,
} from "@stadium/ui/src/components/ModalNew/utils";

const iconData = [
  {
    id: 1,
    icon: styles.fileIcon,
  },
  {
    id: 2,
    icon: styles.globeIcon,
  },
  {
    id: 3,
    icon: styles.giftIcon,
  },
];

const HowItWorksModal = ({ closeModal, data = {} }) => {
  const { isMobileDevice } = data;

  const modifiedHowItWorksData = useMemo(
    () =>
      HOW_IT_WORKS_DATA.map((item) =>
        Object.assign(
          {},
          item,
          iconData.find((itm) => itm.id === item.id),
        ),
      ),
    [],
  );

  const renderHowItWorksModalContent = () => (
    <Modal newModal mobileBottomDrawer className={styles.howItWorksModal} closeModal={closeModal}>
      <ModalDialog className={styles.modalDialogHowItWorks}>
        <ModalContent className={styles.modalContent}>
          <ModalHeader className={styles.modalHeader}>
            <div className={styles.headerContent}>
              <div className={styles.modalTitle}>{HOW_IT_WORKS_HEADING}</div>
              <div className={styles.modalDescription}>{HOW_IT_WORKS_DESCRIPTION}</div>
            </div>
            <CloseButton onClick={closeModal} className={styles.iconClose} />
          </ModalHeader>
          <ModalBody className={styles.modalBody}>
            <div className={styles.howItWorksModalCotnentSection}>
              {modifiedHowItWorksData.map(({ title, description, id, icon }) => (
                <Fragment key={id}>
                  <div className={styles.howItWorksModaContentBlock}>
                    <div className={styles.howItWorksModalContentImageHolder}>
                      <span className={icon} />
                    </div>
                    <div className={styles.howItWorksModalContentBlockTitle}>{title}</div>
                    <div className={styles.howItWorksModalContentBlockDescription}>
                      {description}
                    </div>
                  </div>
                </Fragment>
              ))}
            </div>
          </ModalBody>
          <ModalFooter className={styles.modalFooter}>
            <InternalButton className={styles.buttonDone} onClick={closeModal} styleType="primary">
              DONE
            </InternalButton>
          </ModalFooter>
        </ModalContent>
      </ModalDialog>
    </Modal>
  );

  return isMobileDevice ? (
    <BottomIconHideWrapper>{renderHowItWorksModalContent()}</BottomIconHideWrapper>
  ) : (
    renderHowItWorksModalContent()
  );
};

export default HowItWorksModal;
